import _ from 'lodash'

import AdministratorApi from '@/store/api/system/administrator'

// Team-Zugaenge, die den Event-Scanner benutzen koennen: nicht deaktiviert und
// entweder Inhaber des Webauftritts oder mit Zugriff auf die Event-Verwaltung.
const hasEventAccess = administrator => {
    if (administrator.disabled) return false
    if (!_.get(administrator, 'user.email')) return false
    if (administrator.owner) return true

    const rights = _.get(administrator, 'administratorRights') || []
    return rights.some(right => _.startsWith(right.key, 'ex:evnt') && _.get(right, 'permission.access'))
}

// Auswahlliste fuer die Vorbelegung der App-Anmeldung (?login=… im QR-Code)
export const mapAppLoginOptions = (administrators = []) =>
    administrators
        .filter(hasEventAccess)
        .map(administrator => {
            const user = administrator.user
            const name = user.name || [user.first_name, user.last_name].filter(Boolean).join(' ')

            return {
                email: user.email,
                label: name ? `${name} · ${user.email}` : user.email,
            }
        })
        .sort((one, other) => one.label.localeCompare(other.label))

// Laedt die Team-Zugaenge eines Webauftritts und liefert sie als Auswahlliste.
// Fehler bleiben still: die Vorauswahl ist ein Komfort-Feature, ohne sie
// funktioniert der QR-Code weiterhin.
export const fetchAppLoginOptions = cmsID => {
    if (!cmsID) return Promise.resolve([])

    return AdministratorApi.fetchAdministrators(cmsID)
        .then(administrators => mapAppLoginOptions(administrators || []))
        .catch(() => [])
}
